import rosterTableColumnUrl from './rosterTableColumn.html';

class RosterTableColumnCtrl {
  constructor(sdk) {
    'ngInject';

    this.getShiftDisplayLabels = sdk('model-extensions/getShiftDisplayLabels');
  }

  getShiftTimeLabel() {
    return this.getShiftDisplayLabels(this.data).label;
  }
}

export default function rosterTableColumn() {
  return {
    restrict: 'A',
    templateUrl: rosterTableColumnUrl,
    bindToController: true,
    controllerAs: 'ctrl',
    controller: RosterTableColumnCtrl,
    scope: {
      data: '<',
      type: '<',
      hideScheduleEndTimes: '<',
    },
  };
}
